import type { ChatHeaderComponentProps } from "./_types";

import { useCallback, useImperativeHandle, useMemo, useRef } from "react";

/**
 * ChatHeader Component Hooks
 */
export const useChatHeader = ({
  ref,
  logoUrl,
  chatbotName,
  onOpenSidebar,
  onAddConversation,
  onClose,
  hasMenu,
}: ChatHeaderComponentProps) => {
  /** divRef */
  const divRef = useRef<HTMLDivElement>(null);

  /** useImperativeHandle */
  useImperativeHandle(ref, () => ({ ...divRef.current! }), []);

  /** Handle open sidebar */
  const handleOpenSidebar = useCallback(() => {
    onOpenSidebar?.();
  }, [onOpenSidebar]);

  /** Handle add conversation */
  const handleAddConversation = useCallback(() => {
    onAddConversation?.();
  }, [onAddConversation]);

  /** Handle close */
  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  /** return */
  return useMemo(
    () => ({
      divRef,
      logoUrl,
      chatbotName,
      hasMenu,
      handleOpenSidebar,
      handleAddConversation,
      handleClose,
    }),
    [
      logoUrl,
      chatbotName,
      hasMenu,
      handleOpenSidebar,
      handleAddConversation,
      handleClose,
    ],
  );
};
